/* eslint-disable max-lines */

type ModeColorHues = {
  0?: string;
  10: string;
  20: string;
  30: string;
  '30-opaque'?: string;
  40: string;
  50: string;
  60: string;
  70: string;
  '70-opaque4'?: string;
  '70-opaque6'?: string;
  '70-opaque'?: string;
  80?: string;
  '80-opaque'?: string;
  90?: string;
};
type ModeColor = {
  light: ModeColorHues;
  dark: ModeColorHues;
};

type ModeColorSingle = {
  light: string;
  dark: string;
};

const black: ModeColorSingle = {
  light: '#000000',
  dark: '#000000',
};

const white: ModeColorSingle = {
  light: '#FFFFFF',
  dark: '#EBEBEB',
};

const M: ModeColor = {
  light: {
    10: white.light,
    20: '#F5F5F5',
    30: '#EBEBEB',
    '30-opaque': '#EBEBEB5C',
    40: '#A3A3A3',
    50: '#8F8F8F',
    60: '#767676',
    70: '#141414',
    '70-opaque4': '#1414140A',
    '70-opaque6': '#1414140F',
    '70-opaque': '#1414145C',
  },
  dark: {
    10: '#141414',
    20: '#1F1F1F',
    30: '#292929',
    '30-opaque': '#2929295C',
    40: '#636363',
    50: '#636363',
    60: '#A3A3A3',
    70: '#EBEBEB',
    '70-opaque4': '#EBEBEB0A',
    '70-opaque6': '#EBEBEB0F',
    '70-opaque': '#EBEBEB5C',
  },
};

const R: ModeColor = {
  light: {
    0: '#F54542',
    10: '#FFE4DF',
    20: '#FFC5BB',
    30: '#FF9D90',
    40: '#FF7C70',
    50: '#FB6259',
    60: '#F64A46',
    70: '#E74240',
    80: '#D73F3C',
    90: '#A0332F',
  },
  dark: {
    0: '#F54542',
    10: '#2B1411',
    20: '#4B1E1A',
    30: '#6F2823',
    40: '#8A2E29',
    50: '#A0332F',
    60: '#B33733',
    70: '#C33B37',
    80: '#D33E3B',
    90: '#FB6259',
  },
};

const O: ModeColor = {
  light: {
    0: '#F59103',
    10: '#FFE5CB',
    20: '#FFC992',
    30: '#FCA341',
    40: '#ED8C05',
    50: '#D7800B',
    60: '#C6760E',
    70: '#B76E10',
    80: '#AB6611',
    90: '#804D13',
  },
  dark: {
    0: '#F59103',
    10: '#24180A',
    20: '#3E2710',
    30: '#5A3812',
    40: '#6F4413',
    50: '#804D13',
    60: '#8F5613',
    70: '#9C5D12',
    80: '#A86412',
    90: '#D8800B',
  },
};

const Y: ModeColor = {
  light: {
    0: '#D1CA00',
    10: '#F5ECB6',
    20: '#E0D65A',
    30: '#C3BC08',
    40: '#AEA810',
    50: '#9E9813',
    60: '#9E9813',
    70: '#878216',
    80: '#7F7916',
    90: '#5F5B16',
  },
  dark: {
    0: '#5F5B16',
    10: '#1D1B0B',
    20: '#2F2D11',
    30: '#444114',
    40: '#534F15',
    50: '#605B16',
    60: '#6A6516',
    70: '#736F16',
    80: '#7C7716',
    90: '#9E9813',
  },
};

const G: ModeColor = {
  light: {
    0: '#00BD6E',
    10: '#A2E1B7',
    20: '#A2E1B7',
    30: '#60CC8C',
    40: '#01BC6D',
    50: '#0FAA64',
    60: '#159C5C',
    70: '#189156',
    80: '#198751',
    90: '#1B653E',
  },
  dark: {
    0: '#1B653E',
    10: '#101D15',
    20: '#163220',
    30: '#163220',
    40: '#1B5836',
    50: '#1B653E',
    60: '#1B7144',
    70: '#1B7B4A',
    80: '#1A854F',
    90: '#0FAA64',
  },
};

const B: ModeColor = {
  light: {
    0: '#0569F5',
    10: '#E9E9FF',
    20: '#CECFFE',
    30: '#ABB1FC',
    40: '#919DFA',
    50: '#7A8DF9',
    60: '#6380F8',
    70: '#4B76F7',
    80: '#2F6EF6',
    '80-opaque': '#2F6EF65C',
    90: '#1E52BD',
  },
  dark: {
    0: '#0569F5',
    10: '#16192E',
    20: '#1E2956',
    30: '#223A82',
    40: '#2147A3',
    50: '#1E52BE',
    60: '#195BD5',
    70: '#1063EA',
    80: '#256BF5',
    '80-opaque': '#256BF55C',
    90: '#7A8DF9',
  },
};

const V: ModeColor = {
  light: {
    0: '#AA42F5',
    10: '#F4E4FC',
    20: '#E7C7F9',
    30: '#D6A4F5',
    40: '#C98AF1',
    50: '#BE75EF',
    60: '#B464EC',
    70: '#AC55EA',
    80: '#A448E8',
    90: '#7D34B1',
  },
  dark: {
    0: '#AA42F5',
    10: '#23142C',
    20: '#3C1E51',
    30: '#58287B',
    40: '#6C2F98',
    50: '#7D34B2',
    60: '#8B39C7',
    70: '#983DDA',
    80: '#A243E8',
    90: '#BE75EF',
  },
};

const P: ModeColor = {
  light: {
    0: '#F54298',
    10: '#FFE3ED',
    20: '#FFC1D8',
    30: '#FF98C0',
    40: '#FC77AE',
    50: '#F85BA1',
    60: '#F24296',
    70: '#E03E8B',
    80: '#D13C82',
    90: '#9B3161',
  },
  dark: {
    0: '#F54298',
    10: '#29141C',
    20: '#481E2F',
    30: '#6C2745',
    40: '#852D54',
    50: '#9B3161',
    60: '#AD356C',
    70: '#BD3876',
    80: '#CC3B7F',
    90: '#F85BA1',
  },
};

export const getModeColors = (mode: 'light' | 'dark') => ({
  M: M[mode],
  R: R[mode],
  O: O[mode],
  Y: Y[mode],
  G: G[mode],
  B: B[mode],
  V: V[mode],
  P: P[mode],
  black: black[mode],
  white: white[mode],
  textBase: M[mode][70],
  textSubdued: M[mode][60],
  textPlaceholder: M[mode][40],
  textAccent: B[mode][80],
  textDisabled: M[mode][30],
  textError: R[mode][80],
  surface1: M[mode][10],
  surface2: M[mode][20],
  iconBase: M[mode][60],
  iconHighlighted: M[mode][70],
  iconAccent: B[mode][80],
  iconWarning: R[mode][60],
  borderBase: M[mode][30],
  borderSubdued: M[mode][20],
  borderAccent: B[mode][60],
  borderWarning: R[mode][60],
});
